import qrAnalyticsTypes from "./qrAnalyticsTypes";
import qrAnalyticsApi from "./qrAnalyticsApi";

const qrAnalyticsActions = {
    getQrAnalytics: (branchId, dates, resolve, reject) => async dispatch => {
        dispatch({ type: qrAnalyticsTypes.GET_QR_ANALYTICS_PENDING })
        await qrAnalyticsApi.getQrAnalytics(branchId, dates)
            .then((data) => {
                dispatch({ type: qrAnalyticsTypes.GET_QR_ANALYTICS_SUCCESS, payload: data })
                resolve && resolve()
            })
            .catch((e) => {
                dispatch({ type: qrAnalyticsTypes.GET_QR_ANALYTICS_ERROR })
                reject && reject(e)
            })
    },
}

export default qrAnalyticsActions;
